import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { ContentfulUrlAnchor } from '@clux-models';
import { Categories } from 'src/app/shared/constants/analyticsCategory.constant';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

import { CommonConstants } from '../../constants/common.constant';
import { RouteContextProviderService } from '../../utils/routecontextprovider.service';
import { MoreInfoLinkComponent } from '../more-info-link/more-info-link.component';
import { NgClass } from '@angular/common';
import { AddHtmlDirective } from '../../directives/add-html';
import { MatButton } from '@angular/material/button';
import { UploadFileComponent } from '../upload-file/upload-file.component';

@Component({
  selector: 'app-add-enroll-employee',
  templateUrl: './add-enroll-employee.component.html',
  styleUrls: ['./add-enroll-employee.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MoreInfoLinkComponent, NgClass, AddHtmlDirective, MatButton, UploadFileComponent],
})
export class AddEnrollEmployeeComponent {
  private routecontextprovider = inject(RouteContextProviderService);
  private googleAnalyticsService = inject(GoogleAnalyticsService);

  public uploadFile: boolean;
  @Input() public toggleFlag: boolean;
  @Input() public fileUpload: Model.FileUploadData;
  @Output() public fileUploadSuccess = new EventEmitter();
  public contentfulAnchor = ContentfulUrlAnchor.AddEmployee;
  private pageTitle: string;

  public uploadMultipleEmp(): void {
    this.uploadFile = true;
  }

  public onCancelFileUpload(): void {
    this.uploadFile = false;
  }

  public onFileUploadSuccess(_event: boolean): void {
    this.googleAnalyticsService.eventEmitter(Categories.EventCategories.AddMultipleEmployees);
    this.uploadFile = false;
    this.fileUploadSuccess.emit(true);
  }

  public addSingleEmployee(): void {
    if (this.fileUpload.mainHeader === 'ADD EMPLOYEES') {
      sessionStorage.setItem(CommonConstants.sharedKeys.routeKey, CommonConstants.sharedValues.addEmployee);
      sessionStorage.removeItem(CommonConstants.localKeys.indiviEmployeeInfo);
      sessionStorage.removeItem(CommonConstants.localKeys.individualInfo);
      sessionStorage.removeItem(CommonConstants.localKeys.addedIndividualInfo);
      this.routecontextprovider.navigateTo([CommonConstants.appRoutes.enroll.enrollBase, CommonConstants.appRoutes.enroll.personalInfo]);
    } else {
      this.routecontextprovider.navigateTo([CommonConstants.appRoutes.enroll.enrollBase, CommonConstants.appRoutes.enroll.enrollEmployee]);
    }
  }
}
